import { createContext, type Context as ReactContext } from 'react';

type Context = () => void;
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const defaultValue: Context = () => {};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const { Provider, Consumer } = createContext<Context>(defaultValue) as ReactContext<Context>;
